import { instantsInterceptor, } from '@/api/index';

function getFaqList() {
    return instantsInterceptor.get('/faq/list');
}

function getFaq(boardId) {
    return instantsInterceptor.get('/mgmt/faq/detail/' + boardId);
}

function saveFaq(faq) {
    return instantsInterceptor.post('/mgmt/faq/save', faq);
}

function editFaq(faq) {
    return instantsInterceptor.post('/mgmt/faq/edit', faq);
}

function deleteFaq(faq) {
    return instantsInterceptor.post('/mgmt/faq/delete', faq);
}

function saveNewFaqSort(faqList) {
    return instantsInterceptor.post('/mgmt/faq/sort/edit', faqList);
}

export { getFaqList, getFaq, saveFaq, editFaq, deleteFaq, saveNewFaqSort };